import React from 'react'
import Input from '../../../components/input/input';
import common from '../../../components/form/validators/common'

export default function ProfileRouterAccess({routerAccess, setRouterAccess}) {

    return [

        <Input id='router-user'
            label='Usuário'
            value={routerAccess.username}
            name='router-user'
            onChange={(e) => setRouterAccess({...routerAccess, username: e.target.value})}
            validators={[common.required, common.nonASCII, {fn: common.size, params:{min: 1, max: 32}}]}
            key='router-1'
        ></Input>,

        <Input id='router-pass'
            label='Senha'
            value={routerAccess.password}
            name='router-pass'
            type='password'
            onChange={(e) => setRouterAccess({...routerAccess, password: e.target.value})}
            validators={[
                common.required,
                common.nonASCII,
                common.suspiciousString,
                {fn: common.size, params:{min: 1, max: 30}},
                common.anatelPasswordCriteria,
                common.waekPasswordString
            ]}
            key='router-12'
            passwordMeter={true}
            // strongPasswordRequired={true}
        ></Input>

    ]
}